import API from 'Api';

/**
 * Get list provider from API
 *
 * @return async
 */
export const getListProviderRequest = async (params) => await API.get('/admin/employers', params);